import { render, staticRenderFns } from "./Housekeeper-contract.vue?vue&type=template&id=5fe12e83&scoped=true&"
import script from "./Housekeeper-contract.vue?vue&type=script&lang=js&"
export * from "./Housekeeper-contract.vue?vue&type=script&lang=js&"
import style0 from "./Housekeeper-contract.vue?vue&type=style&index=0&id=5fe12e83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe12e83",
  null
  
)

export default component.exports